import { render, staticRenderFns } from "./PeriodsTable.vue?vue&type=template&id=5218285a&"
import script from "./PeriodsTable.vue?vue&type=script&lang=js&"
export * from "./PeriodsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports